export default Object.freeze({
  NO_NEW_EVIDENCE: 'NO_NEW_EVIDENCE',
  NEW_EVIDENCE_NO_IMPACT: 'NEW_EVIDENCE_NO_IMPACT',
  NEW_EVIDENCE_IMPACTFUL: 'NEW_EVIDENCE_IMPACTFUL',
});
